export function selectorGetCurrentUserRole(state) {
  return state?.entities?.auth?.me?.role;
}

export function selectorGetCurrentUserAccountID(state) {
  return state?.entities?.auth?.me?.accountID;
}

export function selectorGetCurrentUserEmail(state) {
  return state?.entities?.auth?.me?.email;
}

export function selectorGetCurrentUserName(state) {
  return state?.entities?.auth?.me?.name;
}

export function selectorGetCurrentUser(state) {
  return state?.entities?.auth?.me;
}
